import axios from 'axios'
import { Url } from './constantUrl'
import getHeaders from './getHeaders'
import * as types from './types'
import { errorHandler } from './error/errorHandler.action'
import { LOGIN_AUTH } from './types';
import { notify } from '../services/notification'
import getHeadersformdata from './getHeaderFormdata'
import { pageValue } from '../constants/constant'



export const BeatMapPostAction = (params = {}) => async (dispatch) => {
  const url = process.env.REACT_APP_API_URL + Url.CREATE_BeatMap
  let options = Object.assign({ method: 'POST' }, params ? { data: params } : null)
  options.headers = getHeadersformdata()  
  options.url = url
  try {
    const response = await axios(options);
    if (response?.status === 200 || response?.status === 201) {
      return response;
    } else {
      return null;
    }
  } catch (error) {
    if (error?.response) {
      if (error?.response?.status === 400) {
        const errorData = error?.response?.data?.errors;
        
        if (errorData) {
          // Helper function to get error message from array or string
          // const getErrorMessage = (field) => {
          //   return Array.isArray(field) ? field[0] : field;
          // };
          
          // Handles error codes singluar or multiple by using the key array of errorData and mapping the error notifications
          errorData?.map(i => notify.error(i) );

          // Handle other errors or general error message
          // if (!errorData.employee_code && !errorData.mobile_number && !errorData.dsr_id && !errorData?.pincode) {
          //   if (typeof errorData === 'string') {
          //     notify.error(errorData);
          //   } else {
          //     notify.error("An error occurred. Please try again.");
          //   }
          // }
        }

        return error.response;
      } else {
        errorHandler(error);
      }
    } else {
      errorHandler(error);
    }
  }
};

export const BeatMapLogsAction = (page, page_size, query) => dispatch => {
  const url = process.env.REACT_APP_API_URL + Url.BeatMap_LOGS + `?page_size=${page_size}&page=${page}${query ? query : ""}`;
  const options = {
    method: 'GET',
    headers: getHeaders(),
    url: url
  };

  return axios(options)
    .then(response => {
      if (response.status === 200) {
        dispatch({ type: types.GET_BEATMAP_LOGS, payload: response });
        return response;
      } else {
        return null;
      }
    })
    .catch(error => {
      errorHandler(error);
    });
};

export const BeatMapLogsDetailsAction = (logId = null) => dispatch => {
    // If pincode is provided, add it to the URL as query parameter
    const baseUrl = process.env.REACT_APP_API_URL + Url.BeatMap_Details;
    const url = logId ? `${baseUrl}/${logId}` : baseUrl;
    
    const options = {
        method: 'GET',
        headers: getHeaders(),
        url: url
    };
    
    return axios(options)
        .then(response => {
            if (response.status === 200) {
                dispatch({ type: types.GET_BEATMAP_LOGS_DETAILS, payload: response });
                return response;
            } else {
                return null;
            }
        })
        .catch(error => {
            errorHandler(error);
            throw error; // Re-throw to handle in component
        });
};

// export const dowloadMaplistAction = (logId) => async (dispatch) => {
//   const url = `${process.env.REACT_APP_API_URL}${Url.BeatMap_EXCEL}/${logId}`;
//   const headers = getHeaders();
//   try {
//     const response = await fetch(url, {
//       method: 'GET',
//       headers,
//     });

//     if (response.status === 200) {
//       return response.blob();
//     } else {
//       notify.error('Failed to download file');
//       return null;
//     }
//   } catch (error) {
//     errorHandler(error);
//   }
// };

export const dowloadMaplistAction = (logId) => async (dispatch) => {
  const url = `${process.env.REACT_APP_API_URL}${Url.BeatMap_EXCEL}/${logId}`;
  const headers = getHeaders();
  try {
    const response = await fetch(url, {
      method: 'GET',
      headers,
    });
 
    if (response.status === 200) {
      const blob = await response.blob();
      return { blob, responseHeaders: response.headers };
    } else {
      notify.error('Failed to download file');
      return null;
    }
  } catch (error) {
    errorHandler(error);
  }
};
